import { Box } from '@mui/material';
import { random, useCanvasAnimation } from './useCanvasAnimation';

const COLORS = ['#f6d98a', '#ff7a6b', '#7fd3ff', '#b9f28a', '#ffffff'];

type Spark = { x: number; y: number; vx: number; vy: number; life: number; color: string };
type Rocket = { x: number; y: number; targetY: number; color: string };

/** New Year's: a continuous fireworks show inside the header. Render inside a positioned header container. */
export const HeaderFireworks = () => {
  const canvasRef = useCanvasAnimation({
    createStep: () => {
      const rockets: Rocket[] = [];
      let sparks: Spark[] = [];
      let nextLaunch = 0;

      // continuous, so read the live size each frame: a resized header launches within its new bounds
      return (ctx, dt, { width, height }) => {
        nextLaunch -= dt;
        if (nextLaunch <= 0) {
          // a little sparser than a finale, since it runs the whole time the page is open
          nextLaunch = random(600, 1400);
          rockets.push({
            x: random(width * 0.25, width * 0.95),
            y: height,
            targetY: random(10, height * 0.5),
            color: COLORS[Math.floor(random(0, COLORS.length))],
          });
        }

        for (let i = rockets.length - 1; i >= 0; i--) {
          const rocket = rockets[i];
          rocket.y -= dt * 0.14;
          ctx.fillStyle = rocket.color;
          ctx.fillRect(rocket.x, rocket.y, 1.5, 3);
          if (rocket.y <= rocket.targetY) {
            rockets.splice(i, 1);
            for (let k = 0; k < 36; k++) {
              const angle = (k / 36) * Math.PI * 2;
              const speed = random(0.04, 0.075);
              sparks.push({
                x: rocket.x,
                y: rocket.y,
                vx: Math.cos(angle) * speed,
                vy: Math.sin(angle) * speed,
                life: 1,
                color: rocket.color,
              });
            }
          }
        }

        sparks = sparks.filter((s) => s.life > 0);
        for (const s of sparks) {
          s.life -= dt / 1000;
          s.vy += 0.00005 * dt;
          s.x += s.vx * dt;
          s.y += s.vy * dt;
          ctx.globalAlpha = Math.max(0, s.life);
          ctx.fillStyle = s.color;
          ctx.fillRect(s.x, s.y, 1.8, 1.8);
        }
        ctx.globalAlpha = 1;
      };
    },
  });

  return <Box component='canvas' ref={canvasRef} aria-hidden sx={sxStyles.canvas} />;
};

const sxStyles = {
  canvas: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 5,
  },
};
